// var service = require("./../../helper/Rest.js");
import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);

import { service } from "../../helper/Rest.js";
export default {
  userLogin: async (state, cred) => {
    const payload = { apiKey: "sdqwecawecwc", cred };
    console.log(payload);

    const response = await service.login(payload);
    state.commit("changeConectionState", response.success);
    state.commit("addCompanyData", response.business);
    state.commit("setCompanyId", response.business.id);
  },
  GETBUILDINGS: async ({ state, getters, commit }) => {
    var list = (await service.getEdificios(getters.companyID, state.namespace)).data;
    commit("addBuildings", list);
  },
  GETDASHBUILDINGS: async ({ state, commit }, { id_company, id_user }) => {
    var list = (await service.getEdificiosDetallados(id_company, id_user, state.namespace)).data;
    commit("setDashBuildings", list);
  },
  GETCHECKPOINTS: async ({ state, getters, commit }) => {
    var list = (await service.getCheckPoints(getters.companyID, state.namespace)).data;
    commit("addControlPoints", list);
  },
  GETCHECKPOINT: async ({ state, commit }, { id_company, id_checkpoint }) => {
    var cp = (await service.getCheckPoint(id_company, id_checkpoint, state.namespace)).data;
    commit("setCurrentCP", cp);
    //INNECESARIO
    // commit("addCP_id",cp.id)
    // Vue.localStorage.set("cp_id", cp.id)
    return cp;
  },
  GETUSERS: async ({ state, commit }) => {
    var list = (await service.getUsers(state.companyId, state.namespace)).data;
    commit("addUsers", list);
  },
  GETUSER: async ({ state, commit }, user_id) => {
    var obj = (await service.currentUser(user_id)).data;
    commit("addNewUser", obj);
  },
  GETUSERSOWNERS: async ({ state, commit }, user_id) => {
    var obj = (await service.getBusinessOwners()).data;
    commit("addOwners", obj);
  },
  GETOWNERDETAIL: async ({ state, commit }, user_id) => {
    var obj = (await service.getBusinessOwnerDetail(user_id)).data;
    commit("addNewUser", obj);
  },
  CURRENTUSER: async ({ state, commit }) => {
    if (!state.newuser.id) {
      var newuser = (await service.currentUser(state.userId)).data;
      commit("currentUser", newuser);
      console.log(newuser.business.roleIn);
      if (newuser.business.roleIn === "master" || newuser.business.roleIn === "supervisor") {
        console.log("set role master");
        commit("setRoleMaster");
      }
      if(newuser.business.roleIn === "master"){
        console.log("set role master edit");
        commit("setRoleMasterEdit");
      }
    }
    return state.newuser;
  },
  GETUSERINCOMPANY: async ({ state, commit }, { user_id, business_id }) => {
    //eSE USURIO DEBE GUARDARSE EN OTRO STATE PORQUE EL addNewUser es pasra el usario logueado
    var obj = (await service.getUserInCompany(user_id, business_id)).data;
    // commit("addNewUser", obj);
    return obj
  },
  GETTASKS: async ({ state, commit }, checkpoint_id) => {
    var ts = (await service.getTasks(checkpoint_id)).data;
    commit("addTasks", ts);
  },
  POSTCHECKPOINT: async ({ state, commit }, { id_company, obj }) => {
    var cp = (await service.postCheckPoint(id_company, obj, state.namespace)).data;
    commit("setCurrentCP", cp);
    commit("addCP_id", cp.id);
    Vue.localStorage.set("cp_id", cp.id);
    return cp;
  },
  PUTCHECKPOINT: async (
    { state, commit },
    { id_company, id_checkpoint, obj }
  ) => {
    var cp = (await service.putCheckPoint(id_company, id_checkpoint, obj)).data;
    commit("addCP_id", cp.id);
    Vue.localStorage.set("cp_id", cp.id);
    return cp;
  },
  DELETECHECKPOINT: async ({ commit }, { id_company, id_checkpoint }) => {
    var status = (await service.deleteCheckPoint(id_company, id_checkpoint))
      .data;
    commit("addCP_id", "");
    Vue.localStorage.remove("cp_id");
  },
  POSTTASK: async ({ state, commit }, { id_cp, obj }) => {
    var ts = (await service.postTask(id_cp, obj)).data;
    commit("addTask", ts);
    return ts;
  },
  PUTTASK: async ({ state, commit }, { id_cp, id_ts, obj }) => {
    var ts = (await service.putTask(id_cp, id_ts, obj)).data;
  },
  DELETETASK: async ({ state, commit }, { id_ts }) => {
    var ts = (await service.deleteTask(id_ts)).data;
    return ts;
  },
  POSTALTERNATIVE: async ({ state, commit }, { id_task, str }) => {
    var alt = (await service.postAlternative(id_task, str)).data;
    commit("addAlternativa", { id: id_task, val: alt });
  },
  PUTALTERNATIVE: async ({ state, commit }, { id_task, id_alt, str }) => {
    var alt = (await service.putAlternative(id_task, id_alt, str)).data;
  },
  DELALTERNATIVE: async ({ state, commit }, { id_task, id_alt }) => {
    var alt = (await service.delAlternative(id_task, id_alt)).data;
  },
  PUTLINKBUILD: async ({ state, commit }, { id_business, id_user, obj }) => {
    var ts = (await service.putTask(id_business, id_user, obj)).data;
  },
  POSTCPLINKBUILD: async (
    { state, commit },
    { id_checkpoint, id_building }
  ) => {
    var cp = (await service.postCPLinkBuild(id_checkpoint, id_building)).data;
    return cp;
  },
  PUTCPLINKBUILD: async (
    { state, commit },
    { id_checkpoint, id_building, payload }
  ) => {
    var cp = (await service.putCPLinkBuild(id_checkpoint, id_building, payload))
      .data;
    return cp;
  },
  DELCPUNLINKBUILD: async (
    { state, commit },
    { id_checkpoint, id_building }
  ) => {
    var cp = (await service.delCPUnlinkBuild(id_checkpoint, id_building)).data;
    return cp;
  },
  POSTDASHBOARD: async ({ state, commit }, { id_business, obj, namespace }) => {
    var db = (await service.postDashboard(id_business, obj, namespace)).data;
    console.log(db);

    commit("setDashInfo", db);
  },
  POSTDASHBOARDINDICATOR: async ({ state, commit }, { id_business, obj }) => {
    var db = (await service.postDashboardIndicator(id_business, obj)).data;
    console.log(db);

    commit("setDashInfo", db);
  },
  POSTREPORT: async ({ state, commit }, { id_business, obj }) => {
    var rep = (await service.postReport(id_business, obj)).data;
    commit("setReportInfo", rep);
    return rep;
  },
  PUTBUILDING: async ({ state, commit }, { id_building, obj }) => {
    var b = (await service.putEdificio(id_building, obj)).data;
    return b;
  },
  GETSTATSCHECKPOINTDATE: async ({ state, commit }, { id_business, obj }) => {
    var data = (await service.getCheckPointsStats(id_business, obj)).data;
    commit("listStatCP", data.checkpoints);
    commit("createChartOptions", data);
    return data;
  },
  GETSTATSCHECKPOINT: async ({ state, commit }, payload) => {
    var res = await service.getCheckPointsStats(payload);

    if (res.status == 200) {
      commit("listStatCP", res.data.checkpoints);
      commit("createChartOptions", res.data);
    }
    commit("deactiveLoader");
    return res.data;
  },
  GETSTATSUSERS: async ({ state, commit }) => {
    commit("activeLoader");
    let { data } = await service.getUsersStats({
      id: state.companyId,
      namespace: state.namespace
    });
    commit("updateReportuserStats", data);
  },
  GETSTATSUSERSINDICATOR: async ({ state, commit }, payload) => {
    commit("activeLoader");
    let { data } = await service.getUsersStatsIndicator({
      id: state.companyId,
      obj: {...payload, namespace: state.namespace}
    });
    commit("updateReportuserStats", data);
  },
  GETSTATSUSERSDATE: async ({ state, commit }, obj) => {
    commit("activeLoader");
    let { data } = await service.getUsersStats({
      id: state.companyId,
      obj: obj,
      namespace: state.namespace
    });
    commit("updateReportuserStats", data);
    commit("activeLoader");
  },
  GETSTATBYCHECKPOINT: async (
    { state, commit },
    { id_business, id_checkpoint }
  ) => {
    var data = (await service.getCheckPointStats(id_business, id_checkpoint))
      .data;
    commit("updateCurrentCPStats", data);
    commit("optionByCheckpointChart", data);
    return data;
  },
  GETSTATBUILDINGS: async ({ state, commit }, payload) => {
    commit("activeLoader");
    let { data } = await service.getBuildingsStats({
      id: state.companyId,
      ...payload
    });
    commit("buildBuildingsStat", data);
    commit("deactiveLoader");
    return data;
  },
  GETSTATCHECKPOINBUILDING: async ({ state, commit }, payload) => {
    var { data } = await service.getCheckPointBuildingStats({
      id: state.companyId,
      ...payload
    });
    commit("buildBuildingsStat", data);
    // commit("optionByCheckpointChart", data)
    return data;
  },
  GETREPORTERHISTORIC: async ({ state, commit }, payload) => {
    commit("activeLoader");
    var { data, user } = await service.getUserHistoric({
      id: state.companyId,
      ...payload
    });
    commit("drawReporterHistoric", data);
    commit("deactiveLoader");
    return data;
  },
  SETORDERTASKS: async ({ state, commit }, payload) => {
    var { data } = await service.setTaskOrder(payload);
  },
  GETBUSINESSLIST: async ({ commit }) => {
    var res = await service.getBusiness();
    console.log(res);
    commit("setBusinessList", res.data);
  },
  CREATEBUSINESS: async ({ commit }, payload) => {
    var res = await service.createBusiness(payload);
  },
  GETBUSINESSVIEW: async ({ commit }, payload) => {
    var res = await service.getBusinessView(payload);
    commit("setBusinessCurrentView", res.data);
    return res.response;
  },
  UPDATEBUSINESS: async ({ commit }, payload) => {
    var res = await service.updateBusiness(payload);
  },
  LINKBUSINESSOWNER: async ({ commit }, payload) => {
    var res = await service.linkUserOwners(payload);
    console.log(res);
  },
  UNLINKBUSINESSOWNER: async ({ commit }, payload) => {
    var res = await service.unlinkUserOwners(payload);
  },
  GETAPIKEY: async ({ commit }, payload) => {
    var res = await service.getApiKey(payload);
    if (res.status == 200) {
      commit("setApiKey", res.data.apiKey);
      commit("setBusinessImage", res.data.imagefull);
      commit("setSubdomain", payload);
    } else {
      commit("setErrorMessage", res.data);
    }
    return res.status;
  },
  GETBUSINESSALERTS: async ({state,getters}, payload) => {
    const res = await service.getBusinessAlerts({...payload, id: getters.companyID, namespace: state.namespace});
    return res;
  },
  GETBUSINESSALERTSHISTORIC: async ({state,getters}, payload) => {
    console.log("en GETBUSINESSALERTSHISTORIC", payload);
    
    const res = await service.getBusinessAlertsHistoric({...payload, id: getters.companyID, namespace: state.namespace});
    return res
  },
  GETBUSINESSALERTSHISTORICRESUME: async ({state,getters}, payload) => {
    console.log("en GETBUSINESSALERTSHISTORICRESUME", payload);
    
    const res = await service.getBusinessAlertsHistoricResume({...payload, id: getters.companyID, namespace: state.namespace});
    return res
  },
  GETBUSINESSALERTSHISTORICDASHBOARD: async ({state,getters}, payload) => {
    console.log("en GETBUSINESSALERTSHISTORICDASHBOARD", payload);
    
    const res = await service.getBusinessAlertsHistoricDashboard({...payload, id: getters.companyID, namespace: state.namespace});
    return res
  },
  GETALERT: async ({getters}, payload) => {
    const res = await service.getAlert(payload);
    return res;
  },
  CLOSEALERT: async ({},payload) => {
    console.log(payload);
    const res = await service.closeAlert(payload);
    return res
  },
  GETALERTOLDS : async ({state,getters},payload) => {
    const res = await service.getBusinessAlertsOld({...payload, id: getters.companyID, namespace: state.namespace});
    return res
  },
  CLOSEALERTOLDS : async ({getters},payload) => {
    const res = await service.closeBusinessAlertsOld({id: getters.companyID, body: payload});
    return res;
  },
  POSTCOMMENT: async ({}, payload) => {
    const res = await service.postComment(payload);
    return res;
  },
  SETNAMESPACE: ({commit}, payload) => {
    commit("setNamespace", payload);
    localStorage.setItem("namespace", payload);
    window.location.reload()
  },
  DOWNLOADSTATSCHECKPOINTS: async ({},payload) => {
    const res = await service.downloadStatsCheckpoints(payload);
    return res
  },
  GETCHECKPOINTTYPIFICATION: async ({commit}, payload) => {
    const res = await service.checkpointTypefication(payload);
    if(res.status == 200){
      commit("setCheckpointType",res.data)
    }
    
    return res;
  },
  POSTATTACHMENTUPLOAD: async ({commit}, payload) => {
    const res = await service.uploadAttachment(payload);
    return res
  }
};



// WEBPACK FOOTER //
// ./src/vuex/actions/index.js